<template>
    <Admin
        :title="__('Site info', null, $page.props.profile_locale)"
    >

        <div class="grid lg:grid-cols-2 gap-3">
            <div class="col-span-full flex">
                <InputLabel
                    :label="__('Background color', null, $page.props.profile_locale)"
                    type="color"
                    id="color"
                    :size="null"
                    v-model="form.bg_color"
                />
            </div>
            <div>
                <InputLabel
                    type="quill"
                    :inputStyle="'background-color: ' + form.bg_color"
                    v-model="form.content"
                />
            </div>
            <div class="flex flex-col">
                <InputLabel
                    type="file"
                    class="w-full mb-3"
                    v-model="form.image"
                />
                <img
                    v-if="image || (lottery && lottery.value && lottery.value.image)"
                    :src="(lottery && lottery.value && lottery.value.image) && !image ? lottery.value.image : image"
                >
            </div>
            <div class="flex justify-start col-span-full">
                <Button
                    color="gray"
                    padding="md"
                    :class="[ form.isDirty ? '' : 'opacity-50' ]"
                    @click="save()"
                >
                {{__('Update', null, $page.props.profile_locale)}}
                </Button>
            </div>
        </div>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import Button from 'UI/Button';
    import SvgIcon from 'UI/SvgIcon';
    import InputLabel from 'UI/InputLabel';
    import { useForm } from '@inertiajs/inertia-vue3'
    import { ref } from '@vue/reactivity';
    import { watch } from '@vue/runtime-core';

    export default {
        props: {
            lottery: [Array, Object],
        },
        components: {
            Admin, Button, SvgIcon, InputLabel
        },
        setup(props) {

            const form = useForm({
                bg_color: props.lottery && props.lottery.value ? props.lottery.value.bg_color : '#fff',
                content: props.lottery && props.lottery.value ? props.lottery.value.content : null,
                image: props.lottery && props.lottery.value ? props.lottery.value.image : null,
                quill_bg : props.lottery && props.lottery.value ? props.lottery.value.quill_bg : '#e4e4e4',
            })
            const image = ref(null);

            function save(){
                form
                .post(route('update.lottery'), {
                    preserveScroll: true,
                });
            }

            watch(() => form.image, (val) => {
                if(val) getImage(val[0])
            })
            function getImage(file){
                var FR = new FileReader();
                FR.addEventListener("load", function(e) {
                    image.value = e.target.result;
                });
                FR.readAsDataURL( file );
            }

            return {
                form,
                save,
                image,

                getImage,
            }
        },

    }
</script>
